import React, { useEffect } from 'react';
import { CellProps, WithClassname } from '@jsonforms/core';
import merge from 'lodash/merge';
import { NumberInput } from '@mantine/core';
import { WithInputProps } from './interfaces';
import { useDebouncedCallback } from 'use-debounce';
import { getNumberInputWidth } from '../utils/getNumberInputWidth';

export const MantineInputInteger = React.memo(function MantineInputInteger(
  props: CellProps & WithClassname & WithInputProps
) {
  const { data, className, id, enabled, uischema, path, handleChange, config, schema } = props;
  const appliedUiSchemaOptions = merge({}, config, uischema.options);
  const [value, setValue] = React.useState(data);

  const handleDebounceChange = useDebouncedCallback((value: string | number) => {
    handleChange(path, value);
  }, 500);

  const handleOnChange = (value: string | number) => {
    setValue(value);
    handleDebounceChange(value);
  };

  useEffect(() => {
    setValue(data);
  }, [data, setValue]);

  return (
    <NumberInput
      w={getNumberInputWidth(value)}
      maw={320}
      value={value ?? ''}
      onChange={handleOnChange}
      className={className}
      id={id}
      disabled={!enabled}
      autoFocus={appliedUiSchemaOptions.focus}
      step={1}
      min={schema.minimum}
      max={schema.maximum}
      allowDecimal={false}
    />
  );
});
